import { FavoriteStatus } from '@app/data/clients/listsClient/types';
import { HomepageWork } from '@app/data/clients/monolithClients/explore/types';
import { useFavoriteAction } from '@app/hooks/useFavoriteAction';
import { trackGA4AddToFavoriteEventHomePage } from '@app/pages/homepage/analytics';
import { Button, constants } from '@redbubble/design-system';
import { withErrorBoundary } from '@redbubble/next/error-boundary';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';
import { FavoriteIcon } from '../FavoriteIcon';

export const messages = defineMessages({
  addToFavorites: {
    defaultMessage: 'Add to favorites',
  },
  removeFromFavorites: {
    defaultMessage: 'Remove from favorites',
  },
});

export interface FavoriteActionButtonProps {
  //this needs to be able to accept inventoryItems
  work: HomepageWork;
  onAddToList?: () => void;
  favoriteStatuses: FavoriteStatus[] | null;
  size?: string;
  index: number;
}

// Currently this only works with works as it was initially built for the homepage works
// carousel. The intent is for this to be extended to also allow managing inventoryItems
// in lists as well as supported by the lists api. This will need to be extended in the future to enable this.

export const FavoriteActionButton: React.FC<FavoriteActionButtonProps> =
  withErrorBoundary(
    ({
      work,
      favoriteStatuses,
      size = constants.SMALL,
      onAddToList,
      index,
    }) => {
      const intl = useIntl();

      const handleFavorite = () => {
        trackGA4AddToFavoriteEventHomePage({ work, index });
        if (onAddToList) {
          onAddToList();
        }
      };

      const { isFavorited, toggleFavorite } = useFavoriteAction({
        work,
        initialFavoriteStatuses: favoriteStatuses,
        onAddToFavorite: handleFavorite,
      });

      return (
        <Button
          data-testid="add-to-favourites-button"
          elevation={constants.ELEVATION_MEDIUM}
          onClick={toggleFavorite}
          circle
          size={size}
          iconAfter={<FavoriteIcon favorited={isFavorited} size={size} />}
          aria-label={intl.formatMessage(
            isFavorited ? messages.removeFromFavorites : messages.addToFavorites
          )}
          title={intl.formatMessage(
            isFavorited ? messages.removeFromFavorites : messages.addToFavorites
          )}
        />
      );
    }
  );
